const newAdditionReducer = (state = [], {type, restaurants}) => {
    switch(type) {
        case 'SET_NEWADDITION':
            return restaurants;
        default: 
            return state;
    }
}

export default newAdditionReducer;